(function($) {

	'use strict';

  var CONST = {
    collasped:  'data-product-collapsed',
    sectionId:  'data-form-section',
    sectionBtn: 'data-form-section-btn',
    hideSection: 'data-form-hide-section'
  };

  function setAttr(el, attr, value) {
    el.attr(attr, value);
  }

  function handleButtonClick(event) {
    event.preventDefault();

    var sectionId       = $(event.target).eq(0).attr(CONST.sectionBtn);
    var hideSection     = $(event.target).eq(0).attr(CONST.hideSection);
    var selectedSection = $('[' + CONST.sectionId + '="' + sectionId + '"]');

    setAttr(selectedSection, CONST.collasped, false);
    setAttr(selectedSection, 'aria-hidden', false);

    if(hideSection !== undefined) {
        selectedSection = $('[' + CONST.sectionId + '="' + hideSection + '"]');
        setAttr(selectedSection, CONST.collasped, true);
        setAttr(selectedSection, 'aria-hidden', true);
    }

  }

  function init() {
    var $sectionBtn = $('[' + CONST.sectionBtn + ']');
    $sectionBtn.on('click', handleButtonClick);
  }

  init();

})($jq);
